/* CDM B2C COMBO v0.2 — LOCAL / UNPUBLISHED
 * No window global API, no third-party JS, no frontend discount mutation.
 * Preview cannot call cart/add.js. Live mode requires separate release approval.
 */
(function () {
  'use strict';
  if (window.CDMComboScriptLoaded) return;
  window.CDMComboScriptLoaded = true;

  const BRL = new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'});
  // Dinamização V1.5: as faixas são mínimas por variante, nunca autoridade de checkout.
  const fallbackTiers=[{quantity:2,discount_percent:5},{quantity:3,discount_percent:10}];
  function readPreviewOffersFromProduct(root) {
    const raw=root.getAttribute('data-cdm-offers-v1');
    if(!raw||raw==='null')return fallbackTiers;
    try{
      const c=JSON.parse(raw);
      if(!c||c.version!==1||c.enabled===false||!Array.isArray(c.tiers)||!c.tiers.length||c.tiers.length>20)return [];
      const rows=c.tiers.map(t=>{
        if(!t||!Number.isSafeInteger(t.quantity)||t.quantity<2||t.quantity>1000||
           typeof t.discount_percent!=='number'||!Number.isFinite(t.discount_percent)||
           t.discount_percent<=0||t.discount_percent>100||
           Math.abs(t.discount_percent*100-Math.round(t.discount_percent*100))>1e-7)return null;
        return {quantity:t.quantity,discount_percent:t.discount_percent};
      });
      if(rows.includes(null))return [];
      rows.sort((a,b)=>a.quantity-b.quantity);
      for(let i=1;i<rows.length;i++){
        if(rows[i].quantity===rows[i-1].quantity||rows[i].discount_percent<rows[i-1].discount_percent)return [];
      }
      return rows;
    }catch(_e){return [];}
  }
  function discountAtQuantity(tiers,q){
    let result=0;
    for(const row of tiers){if(q<row.quantity)break;result=row.discount_percent;}
    return result;
  }
  function renderQuantityCards(root,tiers,quantityUnit){
    const box=root.querySelector('.cdm-combo__tiers');
    if(!box)return;
    const legend=document.createElement('legend');
    legend.className='visually-hidden';legend.textContent='Quantidade de pacotes';
    const name='cdm-combo-qty-'+(root.dataset.productId||'product');
    const cards=[{quantity:1,discount_percent:0},...tiers].map((row,i)=>{
      const lab=document.createElement('label');lab.className='cdm-combo__tier'+(i===0?' is-selected':'');
      lab.setAttribute('data-cdm-tier-card','');
      const radio=document.createElement('input');
      radio.type='radio';radio.name=name;radio.value=String(row.quantity);
      radio.checked=i===0;radio.setAttribute('data-cdm-tier','');
      const details=document.createElement('span');details.className='cdm-combo__tier-details';
      const t=document.createElement('strong');
      t.textContent=row.quantity+' '+(quantityUnit==='unidade'?(row.quantity===1?'UNIDADE':'UNIDADES'):(row.quantity===1?'PACOTE':'PACOTES'));
      const unit=document.createElement('small');unit.setAttribute('data-cdm-unit','');unit.textContent='Selecione a moagem';
      details.append(t,unit);
      const total=document.createElement('span');total.className='cdm-combo__tier-total';
      const price=document.createElement('strong');price.setAttribute('data-cdm-tier-price','');price.textContent='—';
      const badge=document.createElement('small');badge.setAttribute('data-cdm-tier-badge','');
      badge.textContent=i===0?'Preço individual':'Simulação '+row.discount_percent+'% OFF';
      total.append(price,badge);lab.append(radio,details,total);
      return lab;
    });
    box.replaceChildren(legend,...cards);
  }
  function centsLabel(cents) {return BRL.format(Math.max(0, Math.round(cents)) / 100);}
  function rootPath(raw) {return (raw || window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');}
  function setText(root, selector, value) { const item = root.querySelector(selector); if (item) item.textContent = value; }

  function loadMainVariants() {
    const node = document.getElementById('productVariantsML');
    if (!node) return null;
    try { const data = JSON.parse(node.textContent); return Array.isArray(data) && data.length ? data : null; }
    catch (_e) { return null; }
  }

  function selectedMainVariant(variants) {
    if (!variants || !variants.length) return null;
    const selectors = [...document.querySelectorAll('.product-hero-ml .variant-select-ml')];
    if (!selectors.length) return variants.length === 1 ? variants[0] : null;
    const values = selectors.map(el => el.value);
    if (values.some(value => !value || !String(value).trim())) return null;
    return variants.find(v => Array.isArray(v.options) && v.options.length === values.length &&
      v.options.every((option, index) => String(option) === String(values[index]))) || null;
  }

  function mainQuantityAvailable(variant, requested) {
    if (!variant || !variant.available) return false;
    if (variant.inventory_management && Number.isFinite(Number(variant.inventory_quantity)) &&
        Number(variant.inventory_quantity) >= 0 && requested > Number(variant.inventory_quantity)) return false;
    return true;
  }

  function buildAddon(doc, product) {
    const label = doc.createElement('label'); label.className = 'cdm-combo__addon';
    const input = doc.createElement('input'); input.type = 'checkbox'; input.dataset.cdmAddon = '';
    input.dataset.variantId = String(product.variants[0].id);
    input.dataset.price = String(product.variants[0].price);
    input.setAttribute('aria-label', 'Adicionar ' + product.title);
    label.appendChild(input);
    const image = doc.createElement('img');
    image.alt = ''; image.loading = 'lazy';
    const url = product.featured_image || (product.images && product.images[0]) || '';
    if (typeof url === 'string' && /^https?:\/\//.test(url)) image.src = url;
    else if (typeof url === 'string' && /^\/\//.test(url)) image.src = window.location.protocol + url;
    label.appendChild(image);
    const title = doc.createElement('span'); title.className = 'cdm-combo__addon-name';
    title.textContent = product.title; label.appendChild(title);
    const price = doc.createElement('strong'); price.className = 'cdm-combo__addon-price';
    price.textContent = centsLabel(product.variants[0].price); label.appendChild(price);
    return label;
  }

  async function loadComplementary(root, route, productId) {
    const container = root.querySelector('[data-cdm-addons]');
    if (!container) return;
    const url = route + 'recommendations/products.json?product_id=' + encodeURIComponent(productId) +
      '&intent=complementary&limit=10';
    try {
      const response = await fetch(url, {credentials:'same-origin'});
      if (!response.ok) throw new Error('recommendations_' + response.status);
      const result = await response.json();
      // Restrição deliberada v0.2: somente complementares com variante ÚNICA.
      // Evita inclusão silenciosa de moagem, voltagem ou tamanho incorreto.
      const seen = new Set();
      const safe = (Array.isArray(result.products) ? result.products : []).filter(item => {
        if (!item || String(item.id) === String(productId) || !item.available ||
            !Array.isArray(item.variants) || item.variants.length !== 1) return false;
        const variant = item.variants[0];
        if (!variant || !variant.available || !Number.isSafeInteger(Number(variant.id)) ||
            !Number.isFinite(Number(variant.price)) || Number(variant.price) <= 0 ||
            seen.has(String(variant.id))) return false;
        seen.add(String(variant.id)); return true;
      }).slice(0,3);
      container.replaceChildren();
      if (!safe.length) {
        const empty = document.createElement('p'); empty.className = 'cdm-combo__muted';
        empty.textContent = 'Sem produtos complementares disponíveis no momento.';
        container.appendChild(empty); return;
      }
      safe.forEach(item => container.appendChild(buildAddon(document, item)));
      container.dispatchEvent(new Event('cdm:addons-loaded', {bubbles:true}));
    } catch (_e) {
      container.replaceChildren();
      const warning = document.createElement('p'); warning.className='cdm-combo__muted';
      warning.textContent = 'Complementares temporariamente indisponíveis. Você ainda pode selecionar o café.';
      container.appendChild(warning);
    }
  }

  function init(root) {
    if (root.dataset.ready === 'true') return;
    const variants = loadMainVariants();
    if (!variants) {root.dataset.error = 'missing_variants'; return;}
    // Gate triplo: default PREVIEW, nenhum POST em homologacao ate QA.
    const confirmed = root.dataset.discountsVerified === 'true';
    const mode = root.dataset.mode === 'live' && confirmed &&
      root.dataset.cdmLiveGate === 'approved' ? 'live' : 'preview';
    const productId = root.dataset.productId;
    const route = rootPath(root.dataset.root);
    // Em LIVE apenas seleciona quantidades; valores finais sao da Shopify.
    const tiers=mode === 'live' ? fallbackTiers : readPreviewOffersFromProduct(root);
    const quantityUnit=root.dataset.cdmQuantityUnit==='unidade'?'unidade':'pacote';
    // G11.1: estimativa visual APENAS para os cinco produtos explicitamente identificados.
    // A elegibilidade e o preco final continuam no Discounty/Shopify; nenhuma alteracao no cart API.
    const visualOffer = mode === 'live' && root.dataset.cdmVisualOffer === 'true';
    renderQuantityCards(root,tiers,quantityUnit);
    const discountForQuantity=(qty)=>(mode==='preview'||visualOffer)?discountAtQuantity(tiers,qty):0;
    let loading = false;
    const errors = root.querySelector('[data-cdm-error]');
    const button = root.querySelector('[data-cdm-submit]');
    const buyButton = root.querySelector('[data-cdm-buy]');
    const feedback = root.querySelector('[data-cdm-feedback]');

    function showError(message) {errors.textContent=message;errors.hidden=false;feedback.textContent='';}
    function clearError() {errors.textContent='';errors.hidden=true;}
    function selectedQuantity() {
      const radio = root.querySelector('[data-cdm-tier]:checked');
      return radio ? Number(radio.value) : 1;
    }
    function addons() {
      return [...root.querySelectorAll('[data-cdm-addon]:checked')].map(box => ({
        id: Number(box.dataset.variantId), quantity: 1, price: Number(box.dataset.price)
      }));
    }
    function state() {
      const variant = selectedMainVariant(variants);
      const quantity = selectedQuantity();
      const basePrice = variant ? Number(variant.price) : 0;
      const rawMain = basePrice * quantity;
      const discount = discountForQuantity(quantity);
      const main = Math.round(rawMain * (100 - discount) / 100);
      const extras = addons();
      const addonsTotal = extras.reduce((sum, extra) => sum + extra.price, 0);
      const total = main + addonsTotal;
      return {variant, quantity, main, extras, addonsTotal, total, saving: rawMain - main};
    }
    function render() {
      const item = state();
      const legacyQty = document.getElementById('qtyML');
      if (legacyQty) legacyQty.value = String(item.quantity);
      for (const card of root.querySelectorAll('[data-cdm-tier-card]')) {
        const input = card.querySelector('[data-cdm-tier]');
        const qty = Number(input.value);
        const amt = item.variant ? Number(item.variant.price) : 0;
        const pct = discountForQuantity(qty);
        const total = Math.round(amt * qty * (100 - pct) / 100);
        card.classList.toggle('is-selected', input.checked);
        // G6.2: exibe sempre um valor numerico legivel. Em LIVE, sem simular descontos.
        // O desconto efetivo continua sendo calculado somente pela Shopify no carrinho.
        card.querySelector('[data-cdm-tier-price]').textContent = item.variant ? centsLabel(total) : '—';
        card.querySelector('[data-cdm-unit]').textContent = item.variant ? centsLabel(Math.round(total / qty)) + ' por ' + quantityUnit : 'Selecione a variante do café';
        const badge = card.querySelector('[data-cdm-tier-badge]');
        badge.textContent = mode === 'preview' ? (qty === 1 ? 'Preço normal' : 'Simulação ' + pct + '% OFF') :
          (visualOffer ? (qty === 1 ? 'Preço normal' : pct + '% OFF · estimado') :
          (qty === 1 ? 'Preço normal' : 'Valor antes de descontos'));
      }
      setText(root,'[data-cdm-main-label]',item.quantity + (item.quantity===1?' '+quantityUnit:' '+quantityUnit+'s'));
      setText(root,'[data-cdm-main-value]',item.variant ? centsLabel(item.main) : '—');
      setText(root,'[data-cdm-addons-value]',centsLabel(item.addonsTotal));
      setText(root,'[data-cdm-grand]',item.variant ? centsLabel(item.total) : '—');
      if (mode === 'live') setText(root,'.cdm-combo__grand span',visualOffer?'Subtotal estimado, antes do Pix':'Subtotal antes de descontos');
      setText(root,'[data-cdm-saving-value]','− ' + centsLabel(item.saving));
      const savingRow = root.querySelector('[data-cdm-saving-row]');
      savingRow.hidden = !item.saving;
      return item;
    }

    if (mode === 'live') {
      if (!confirmed) setText(root, '.cdm-combo__heading', 'Escolha a quantidade');
      button.textContent = 'ADICIONAR SELECIONADOS AO CARRINHO →';
      if (buyButton) {
        const label=buyButton.querySelector('span');
        if (label) label.textContent='Comprar agora';
      }
      setText(root,'[data-cdm-tier-helper]',visualOffer
        ? 'Preços com desconto progressivo estimado de 5% (2 un.) e 10% (3+). Confira o valor final no carrinho e checkout.'
        : 'Escolha a quantidade. O Shopify calcula os descontos aplicáveis no carrinho e checkout.');
      root.querySelector('[data-cdm-preview-badge]').hidden = true;
      setText(root,'[data-cdm-disclaimer]',
        visualOffer
          ? 'Estimativa visual sujeita à vigência e elegibilidade da campanha Discounty. O desconto real é definido no carrinho e checkout Shopify. Pix, frete e recompensas não incluídos.'
          : 'Valores antes de descontos, frete, cupons e fidelidade. O Shopify calcula o total final no carrinho e checkout.');
    }

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-cdm-tier], [data-cdm-addon]')) {clearError();render();}
    });
    document.addEventListener('change', function (event) {
      if (event.target.closest('.product-hero-ml .variants-ml')) {clearError();queueMicrotask(render);}
    });
    document.addEventListener('click', function (event) {
      if (event.target.closest('.product-hero-ml .variant-choice-button-ml')) queueMicrotask(render);
    });
    root.querySelector('[data-cdm-addons]').addEventListener('cdm:addons-loaded', render);
    async function submitSelection(directCheckout) {
      if (loading) return;
      clearError(); feedback.textContent='';
      const item = render();
      if (!item.variant) {
        showError('Selecione Grãos ou Moído antes de continuar.');
        const picker = document.querySelector('.product-hero-ml [data-grind-choice-group] input');
        if (picker) picker.focus();
        return;
      }
      if (!mainQuantityAvailable(item.variant, item.quantity)) {
        showError('Quantidade indisponível para a variante escolhida.');return;
      }
      if (mode === 'preview') {
        feedback.textContent = (directCheckout ? 'Prévia Comprar agora: ' : 'Prévia Adicionar ao carrinho: ') + item.quantity + ' '+quantityUnit+'(s), ' + item.extras.length +
          ' complemento(s), total demonstrativo ' + centsLabel(item.total) + '. Nenhum item enviado à Shopify.';
        return;
      }
      // G5: validar integridade de variante, quantidade e complementos antes do POST.
      // O carrinho/checkout Shopify continuam sendo a autoridade de preços/descontos.
      const safeVariantId = Number(item.variant.id);
      if (!Number.isSafeInteger(safeVariantId) || safeVariantId <= 0 ||
          !Number.isSafeInteger(item.quantity) || item.quantity < 1 ||
          !item.extras.every(extra => Number.isSafeInteger(extra.id) && extra.id > 0 &&
            Number.isSafeInteger(extra.quantity) && extra.quantity === 1)) {
        showError('Não foi possível validar os itens selecionados. Atualize a página e tente novamente.');
        return;
      }
      const items = [{id:safeVariantId,quantity:item.quantity},
                     ...item.extras.map(extra=>({id:extra.id,quantity:1}))];
      loading=true;button.disabled=true;
      if (buyButton) buyButton.disabled=true;
      if (directCheckout && buyButton) buyButton.querySelector('span').textContent='PROCESSANDO…';
      else button.textContent='ADICIONANDO…';
      try {
        const response = await fetch(route + 'cart/add.js', {method:'POST',credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items})});
        const data = await response.json().catch(()=>({}));
        if (!response.ok) throw new Error((data && (data.description || data.message)) || 'Não foi possível adicionar os produtos.');
        feedback.textContent = 'Itens adicionados ao carrinho. Consulte o total definitivo.';
        // Redirecionamento ao carrinho: evita mostrar economia não comprovada no checkout.
        window.location.assign(route + (directCheckout ? 'checkout' : 'cart'));
      } catch (error) {
        showError(error instanceof Error ? error.message : 'Falha ao adicionar produtos.');
            } finally {
        loading=false;
        button.disabled=false;
        if (buyButton) {
          buyButton.disabled=false;
          const txt=buyButton.querySelector('span');
          if (txt) txt.textContent='Comprar agora';
        }
        button.textContent='ADICIONAR SELECIONADOS AO CARRINHO →';
      }
    }

    button.addEventListener('click', function () {void submitSelection(false);});
    if (buyButton) buyButton.addEventListener('click', function () {void submitSelection(true);});
    root.dataset.ready = 'true';
    render();
    if (productId && /^\d+$/.test(productId)) void loadComplementary(root, route, productId);
    else {setText(root,'[data-cdm-addons]','Complementares não disponíveis nesta prévia.');}
  }

  function boot() {document.querySelectorAll('[data-cdm-combo]').forEach(init);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
